<form [formGroup]="stringFiltersForm" (ngSubmit)="onSubmit()" class="mt-3">
  @for (item of stringFiltersFormArray.controls; track item; let i = $index) {
    <div formArrayName="items">
      <div [formGroupName]="i" class="form-group form-row">
        <div class="col-sm-2">
          <select formControlName="selectedAttribute" class="form-control form-control-sm">
            <option value=""></option>
            @for (attribute of jobFilterAttributeSet; track attribute) {
              <option class="text-sm" [value]="attribute">
                {{ attribute }}
              </option>
            }
          </select>
        </div>
        <div class="col-sm-1">
          <select formControlName="selectedComparison" class="form-control form-control-sm">
            @for (comparison of jobFilterComparisonSet; track comparison) {
              <option class="text-sm" [value]="comparison">
                {{ comparison }}
              </option>
            }
          </select>
        </div>
        <div class="col-sm-2">
          <input type="text" formControlName="value" placeholder="" class="form-control form-control-sm" />
        </div>
        <div class="col-sm-1">
          <!-- without type="button" the enter key in the input fields triggers this button -->
          <button
            type="button"
            class="btn btn-sm btn-outline-dark btn-no-border"
            (click)="deleteFilter(i)"
            title="Delete filter">
            <span class="fas fa-times"></span>
          </button>
        </div>
      </div>
    </div>
  }

  <div [formGroup]="startDateTimeFilterForm" class="form-group form-row">
    <label class="col-sm-2 col-form-label">Created after</label>
    <div class="col-sm-2">
      <input
        type="text"
        formControlName="dateInput"
        ngbDatepicker
        #sd="ngbDatepicker"
        (focus)="sd.open()"
        placeholder="yyyy-mm-dd"
        class="form-control form-control-sm" />
    </div>
    <div class="col-sm-2">
      <input type="time" formControlName="timeInput" class="form-control form-control-sm" />
    </div>
  </div>

  <div [formGroup]="endDateTimeFilterForm" class="form-group form-row">
    <label class="col-sm-2 col-form-label">Created before</label>
    <div class="col-sm-2">
      <!-- <input type="date" formControlName="dateInput" class="form-control form-control-sm"> -->
      <input
        type="text"
        formControlName="dateInput"
        ngbDatepicker
        #ed="ngbDatepicker"
        (focus)="ed.open()"
        placeholder="yyyy-mm-dd"
        class="form-control form-control-sm" />
    </div>
    <div class="col-sm-2">
      <input type="time" formControlName="timeInput" class="form-control form-control-sm" />
    </div>
  </div>

  <div class="form-group form-row">
    <div class="col-sm-1">
      <button class="btn btn-sm btn-info form-control form-control-sm" type="submit">Search</button>
    </div>
    <div class="col-sm-2">
      <button class="btn btn-sm btn-info form-control form-control-sm" (click)="addItem()">Add another field</button>
    </div>
    <div class="col-sm-2">
      <button class="btn btn-sm btn-info form-control form-control-sm" (click)="reset()">Reset form</button>
    </div>
  </div>
</form>

<div class="row">
  <div class="col-sm-3">
    <span class="text-sm">Jobs found: {{ jobNumber }}</span>
  </div>
  <div class="col-sm-9">
    <ngb-pagination
      class="d-flex justify-content-center"
      [collectionSize]="collectionSize"
      [directionLinks]="true"
      [maxSize]="10"
      [(page)]="page"
      (pageChange)="onPageChange(page)"></ngb-pagination>
  </div>
</div>

@if (jobListLoading) {
  <div class="row">
    <div class="col">
      <i class="fas fa-circle-notch fa-spin" style="font-size: 22px"></i>
      Loading job list..
    </div>
  </div>
} @else {
  <table class="table">
    <thead>
      <tr>
        <th scope="col">Username</th>
        <th scope="col">Module</th>
        <th scope="col">Tool</th>
        <th scope="col">Created</th>
        <th scope="col">Duration</th>
        <th scope="col"></th>
        <th scope="col">Status</th>
        <th scope="col">Memory usage</th>
        <th scope="col">Storage usage</th>
        <th scope="col">Comp</th>
      </tr>
    </thead>
    <tbody>
      @for (jobhistory of jobs; track jobhistory.jobId) {
        <tr class="text-sm">
          <td>{{ jobhistory.createdBy }}</td>
          <td>{{ jobhistory.module }}</td>
          <td>{{ jobhistory.toolId }}</td>
          <td>{{ toShortDateTime(jobhistory.created) }}</td>
          <td>{{ getDuration(jobhistory) }}</td>
          <td>
            @if (jobhistory.screenOutput) {
              <button class="btn btn-sm btn-outline-info" (click)="openJobOutputModal(jobhistory)">Output</button>
            }
          </td>
          <td>
            {{ jobhistory.state }}
            @if (jobhistory.stateDetail) {
              <span>({{ jobhistory.stateDetail }})</span>
            }
          </td>
          <td>
            @if (jobhistory.memoryUsage !== 0) {
              <span>{{ jobhistory.memoryUsage | bytes }}</span>
            }
          </td>
          <td>
            @if (jobhistory.storageUsage !== 0) {
              <span>{{ jobhistory.storageUsage | bytes }}</span>
            }
          </td>
          <td>{{ jobhistory.comp }}</td>
        </tr>
      }
    </tbody>
  </table>
}
